export const getInviteLink = (invite = '', type = '') => `${window.location.origin}/invite/${invite}/${type}`;
